import React from 'react';
import './Newsletters.css';

export default function NewslettersList(props) {

    // Array of PDFs with name and URL
    const pdfFiles = [
        { name: "Outreach Brochure 2024", url: "/pdfs/OUTREACH BROCHURE 24.pdf" },
        { name: "Academic Outreach Newsletter January 2024", url: "/pdfs/Academic Outreach Newsletter Jan 24.pdf" },
        { name: "Academic Outreach Newsletter August 2024", url: "/pdfs/Academic Outreach Newsletter Aug 24.pdf" },
    ];

    return (
        <section className="newsletter-section">
            <h1>Newsletters</h1>
            <ul>
                {pdfFiles.map((pdf, index) => (
                    <li key={index}>
                        <a href={pdf.url} download>{pdf.name}</a>
                    </li>
                ))}
            </ul>
        </section>
    );
}
